import { Component } from '@angular/core';

type SissCloudLoadingState = 'auth' | 'upload';

@Component({
    selector: 'se-siss-cloud-loading',
    templateUrl: './siss-cloud-loading.component.html',
    styleUrls: ['./siss-cloud-loading.component.scss'],
})
export class SissCloudLoadingComponent {
    state: SissCloudLoadingState = 'auth';
}
